module.exports = __webpack_public_path__ + "static/media/gal0024.d96ce974.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal00/gal0024.jpg
// module id = 284
// module chunks = 0